import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  MenuItem
} from "@mui/material";
import { useDeleteServerMutation, useGetServerQuery, useGetDomainQuery } from "../../../Api/attoDeskApi";
import { IServers, IDomains } from "../../../Api/Interface/api.interface";
import NewPopUpTax from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import moment from 'moment';
import axios from "axios";
import LinkIcon from '@mui/icons-material/Link';

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
const { id } = useParams<{ id: string }>();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const API_URL = process.env.REACT_APP_API_URL;
  const [selectedCoursing, setSelectedCoursing] = useState<IServers | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IServers | null>(null);
  const [selectedDomain, setSelectedDomain] = useState("");
const [expiryDate, setExpiryDate] = useState("");
  const [renewalCost, setRenewalCost] = useState("");
const [allocatedList, setAllocatedList] = useState<any[]>([]);

  const { data, isLoading, isError, refetch } = useGetServerQuery({
    searchText: currentSearchQuery,
  });

const { 
  data: serverData, 
  isLoading: serverLoading, 
  isError: serverError, 
  refetch: serverRefresh 
} = useGetServerQuery({
  id: id,              
  searchText: "",     
});


const { 
  data: domainData, 
  isLoading: domainLoading, 
  isError: domainError, 
  refetch: domainRefresh 
} = useGetDomainQuery({
    searchText: "",
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IServers) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IServers) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const [deleteCategory] = useDeleteServerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the server");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the server");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IServers[] = Array.isArray(data?.data)
    ? (data?.data as IServers[])
    : [];

  const serverDetail: IServers[] = Array.isArray(serverData?.data)
    ? (serverData?.data as IServers[])
    : [];

  const domainList: IDomains[] = Array.isArray(domainData?.data)
    ? (domainData?.data as IDomains[])
    : [];

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/server/create");
  };

// Add new allocation
const handleAllocate = async () => {
  if (!selectedDomain || !expiryDate) return;

  const newAllocation = { domainId: Number(selectedDomain), expiryDate , renewalCost};
  const updatedList = [...allocatedList, newAllocation];

  try {
    await axios.post(`${API_URL}/server/allocate-domain`, {
      id,
      allocatedDomains: updatedList, // send full updated list
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
    });

    setAllocatedList(updatedList); // update local state
    showMessage("Domain allocated successfully");
    domainRefresh();
    setSelectedDomain("");
    setExpiryDate("");
  } catch (error) {
    console.error(error);
    showErrorMessage("Failed to allocate domain");
  }
};

// Delete allocation
const handleDeleteAllocation = async (domainId: any) => {
  const updatedList = allocatedList.filter(d => d.domainId !== domainId);

  try {
    await axios.post(`${API_URL}/server/allocate-domain`, {
      id,
      allocatedDomains: updatedList, // send full updated list
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
    });

    setAllocatedList(updatedList);
    showMessage("Domain removed successfully");
    domainRefresh();
  } catch (error) {
    console.error(error);
    showErrorMessage("Failed to remove domain");
  }
};



  return (

    <><Card className={classes.card} sx={{ mb: 3 }}>
      <Grid
        container
        spacing={2}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
       
  {isError || serverDetail.length === 0 ? (
    <Grid item xs={12} textAlign="center">
      {isError ? "Error fetching data" : "No data available"}
    </Grid>
  ) : (
    serverDetail
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((row: IServers, index) => (
       <Card key={row.id} className={classes.card} sx={{ mb: 2, p: 2 }}>
  <Grid container spacing={3}>
    {[
      { label: 'Customer', value: row.customer?.customerFirstName ?? '-' },
      { label: 'Type', value: row.server?.name ?? '-' },
      { label: 'Company', value: row.company?.name ?? '-' },
      { label: 'Server Name', value: row.serverName ?? '-' },
      { label: 'ID', value: row.serverId ?? '-' },
      { label: 'Expiry Date', value: row.expiryDate ? moment(row.expiryDate).format('DD-MMM-YY') : '-' },
    ].map((field) => (
      <Grid item xs={12} sm={6} md={4} key={field.label}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="body1"
            component="span"
            sx={{ width: 120, fontWeight: 'bold' }} // bold and fixed width
          >
            {field.label}
          </Typography>
          <Typography variant="body1" component="span">
            {field.value}
          </Typography>
        </Box>
      </Grid>
    ))}
  </Grid>
</Card>

      ))
  )}
</Grid>

    </Card>
    
    <Card className={classes.card}>
        <Grid
          container
          spacing={2}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}>Allocate Domain</Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
              {/* <Grid item>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Name & Code .."
                  sx={{ width: "100%" }}
                  size="small" />
              </Grid>

              <Grid item>
                <Button
                  variant="contained"
                  className={classes.addButton}
                  onClick={handleAddProductClick}
                >
                  Add Server
                </Button>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>

  <Grid container spacing={2} sx={{ p: 4 }}>
    
    <Grid item xs={12} sm={3}>
      <TextField
        select
        fullWidth
        label="Select Domain"
        value={selectedDomain}
        onChange={(e) => setSelectedDomain(e.target.value)}
        size="small"
      >
        {domainList.map((domain) => (
          <MenuItem key={domain.id} value={domain.id}>
            {domain.name}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

   

    <Grid item xs={12} sm={3}>
      <TextField
        type="date"
        fullWidth
        label="Expiry Date"
        InputLabelProps={{ shrink: true }}
        value={expiryDate}
        onChange={(e) => setExpiryDate(e.target.value)}
        size="small"
      />
    </Grid>
     <Grid item xs={12} sm={3}>
      <TextField
        fullWidth
        label="Renewal Cost"
        InputLabelProps={{ shrink: true }}
        value={renewalCost}
        onChange={(e) => setRenewalCost(e.target.value)}
        size="small"
      />
    </Grid>

    <Grid item xs={12} sm={3} display="flex" alignItems="center">
      <Button
        variant="contained"
        onClick={handleAllocate}
          className={classes.addButton}
      >
        Allocate
      </Button>
    </Grid>
  </Grid>



        <Grid>
          <TableContainer>
            <Table className={classes.table}>
              <TableHead className={classes.tableHeaderRow}>
                <TableRow>
                  {/* <TableCell className={classes.tablheader}>
                    <CustomCheckbox name="checkbox" />
                  </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>#</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Name</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Customer</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Domain Provider</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Domain Expiry Date</strong>
                  </TableCell>
                 
                  <TableCell className={classes.tablheader}>
                    <strong>Server Expiry Date</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Renewal Cost</strong>
                  </TableCell>
                  <TableCell
                    className={classes.tablheader}
                    sx={{ textAlign: "right" }}
                  >
                    <strong>Actions</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || domainList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={20} align="center">
                      {isError ? "Error fetching data" : "No data available"}
                    </TableCell>
                  </TableRow>
                ) : (
                  domainList
                  .filter((row: IDomains) => String(row.server_id) === id) 
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IDomains, index) => (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>

                         <TableCell scope="row" className={classes.tablCell}>
                          {row.name}
                        </TableCell>

                      <TableCell component="th"
  scope="row"
  className={classes.tablCell}
  sx={{ whiteSpace: "nowrap"}}>
    <span style={{ display: "inline-flex", alignItems: "center" }}>
                         {row.customer ? row.customer.customerFirstName : "-"}
            {row.customer?.id && (
                          <Link 
      to={`/customer-history/${row.customer.id}`} 
        style={{ textDecoration: 'none', marginLeft: "6px", color: 'inherit' }}
    > 
            <LinkIcon fontSize="small" style={{ verticalAlign: "middle" }} />
    </Link>
    
      )}
      </span>
                        </TableCell>

                      <TableCell scope="row" className={classes.tablCell} sx={{ whiteSpace: "nowrap" }}>
  <span style={{ display: "inline-flex", alignItems: "center" }}>
    {row.domain_provider?.name} - {row.domain_provider?.company?.name}
    {row.domain_provider?.id && (
      <Link 
        to={`/domainProvider/history/${row.domain_provider.id}`} 
        style={{ textDecoration: 'none', marginLeft: "6px", color: 'inherit' }}
      > 
        <LinkIcon fontSize="small" style={{ verticalAlign: "middle" }} />
      </Link>
    )}
  </span>
</TableCell>


                       
                        {/* Expiry Date */}
                        <TableCell scope="row" className={classes.tablCell}>
                          {row.expiryDate ? moment(row.expiryDate).format('DD-MMM-YY') : "-"}
                        </TableCell>

                         <TableCell scope="row" className={classes.tablCell}>
                          {row.server_expiry_date ? moment(row.server_expiry_date).format('DD-MMM-YY') : "-"}
                        </TableCell>

                         <TableCell scope="row" className={classes.tablCell}>
                          {row.renewalCost ? row.renewalCost: "-"}
                        </TableCell>

                        <TableCell className={classes.tablCell}>
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            {/* <Grid item>
                              <Button
                                variant="contained"
                                className={classes.editButtonList}
                                onClick={() => handleOpenDialog(row)}
                              >
                                <EditSharpIcon className={classes.editListIcon} />
                              </Button>
                            </Grid> */}
                            <Grid item>
                              <Button
                                variant="contained"
                                className={classes.deleteButtonList}
                                onClick={() => handleDeleteAllocation(row.id)}
                              >
                                <DeleteOutlineSharpIcon
                                  className={classes.deleteListIcon} />
                              </Button>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
            <Grid
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination
                  count={coursings.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>
          {selectedCoursing && (
            <NewPopUpTax
              openModel={openDialog}
              handleCloseDialog={handleCloseDialog}
              data={selectedCoursing} />
          )}
          {coursingToDelete && (
            <DeletePopup
              open={openDeleteCategory}
              handleCloseDelete={handleCloseDeletePopup}
              onConfirm={async () => {
                await handleDelete(coursingToDelete?.id.toString());

              } }
              title="Delete Server"
              content={`Are you sure you want to delete "${coursingToDelete.serverName}"?`} />
          )}
        </Grid>
      </Card></>
  );
};

export default Index;
